import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { PerformanceConflict, QueryConflictsDto } from '../model/recital';

export interface GetConflictsParams {
  recitalId: string;
  filters?: QueryConflictsDto;
}

export const getConflictsAPI = async ({
  recitalId,
  filters,
}: GetConflictsParams) => {
  const response = await baseAPI.get<Array<PerformanceConflict>>(
    `/recitals/${recitalId}/conflicts`,
    { params: filters },
  );
  return response.data;
};

export interface UseConflictsParams extends GetConflictsParams {
  enabled?: boolean;
}

export const getConflictsOptions = (params: UseConflictsParams) => ({
  queryKey: [KEYS.CONFLICTS, params.recitalId, params.filters],
  queryFn: () => getConflictsAPI(params),
  enabled: params.enabled !== false,
});

export const useConflictsQuery = (params: UseConflictsParams) => {
  return useQuery(getConflictsOptions(params));
};
